<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="targetTitle" width="700px" @close="close">
    <div slot="content">
      <el-steps :active="activeStep" finish-status="success">
        <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
      </el-steps>
      <el-form v-show="activeStep === 1" ref="formData" :model="formData" :rules="rules">
        <el-row :gutter="20">
          <el-form-item prop="policyId" label="정책 ID">
            <el-input :disabled="popupMode === 'update'" v-model="formData.policyId"></el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item prop="policyDescr" label="정책 명">
            <el-input v-model="formData.policyDescr"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <el-row v-show="activeStep === 2">
        <span class="title-h4">{{this.targetData.objCompanyName}} 룰 목록</span>
        <el-table-wrapper @selection-change="changeHandleSelection" style="padding-top: 20px; width:100%;" ref="settingRuleList" :data="ruleTableData"
          :columns="tableColumn" :column-default="columnDefault" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool">
        </el-table-wrapper>
      </el-row>
      <el-row v-show="activeStep === 3">
        <el-row class="title-bar" type="flex" justify="space-between">
          <span class="title-h4">장비목록</span>
          <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
        </el-row>
        <el-table-wrapper @selection-change="changeHandleSelection" style="width:100%;" ref="deviceTable" :data="nonPolicyTableData"
          :columns="devicetableColumn" :column-default="columnDefault" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool">
        </el-table-wrapper>
      </el-row>
      <el-row v-show="activeStep === 4">
        <el-row type="flex" justify="space-between" align="middle">
          <div class="title-h4">스케줄 등록여부</div>
          <el-switch style="margin-bottom: 15px;" v-model="formData.scheduleFlag" active-value="Y" inactive-value="N"></el-switch>
        </el-row>
        <el-form  class="mr-b25" v-show="(formData.scheduleFlag === 'Y')" ref="scheduleForm" :model="scheduleForm">
          <el-form-item label="스케줄 명" prop="scheduleName" >
            <el-input v-model="scheduleForm.scheduleName" />
          </el-form-item>
        </el-form>
        <el-row v-show="(formData.scheduleFlag === 'Y')">
          <div class="title-h4 title-bar">주기 설정</div>
          <w-period-setting-component v-if="periodCompFlag" ref="periodSettingCmp" />
        </el-row>
      </el-row>
    </div>
    <div slot="footer" >
      <el-row type="flex" justify="space-between">
        <div>
          <el-button v-show="(activeStep !== 1)" size="large" @click="prevStep">
            <i class="fal fa-arrow-left mr-r2"></i>이전
          </el-button>
        </div>
        <div>
          <el-button size="large" v-show="(activeStep == 1 || activeStep == 3)" type="solid"  @click="onClickNextStep">다음</el-button>
          <el-button size="large" v-show="activeStep === 2" type="solid" @click="onClickNextStep" :disabled="selectedRowArrayForRule.length === 0">다음</el-button>
          <el-button size="large" v-show="activeStep === 4" type="solid" @click="onClickSaveButton">저장</el-button>
          <el-button size="large" @click="clickCloseBtn">취소</el-button>
        </div>
      </el-row>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { cloneDeep, EMPTY_TEXT, isEmpty, parseInt, forEach, findIndex, isUndefined, find, map, differenceWith } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import NetdeviceSecurityPolicySettingsAPI from '@/api/settings/netdevice/netdevice-security-policy-settings';
import WPeriodSettingComponent from '@/views/settings/components/PeriodSettingComponent';

export default {
  name: 'WAddSecurityPolicySlidingPopup',
  components: {
    WPeriodSettingComponent,
  },
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rules: {
        policyId: { required: true, trigger: 'blur', validator: this.checkPolicyId },
        policyDescr: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
      formData: {
        scheduleFlag: 'Y',
        policyId: '',
        policyDescr: '',
      }, // 정책 기본 정보
      scheduleForm: {
        scheduleName: '',
      }, // 스캐줄 이름
      selectedRowArrayForRule: [], // 선택한 룰 리스트
      selectedRowArrayForDevice: [], // 선택한 장비 리스트
      targetTitle: '',
      popupMode: 'add',
      periodCompFlag: true,
      activeStep: 1,
      nonPolicyTableData: [],
      showSearchTool: false,
      stepTitles: ['기본 정보', '룰 선택', '적용장비 선택', '스케줄링'],
      ruleTableData: [],
      columnDefault,
      tableColumn: [
        {
          type: 'selection',
          width: 50,
        },
        {
          prop: 'ruleId',
          label: '룰 아이디',
          sortable: true,
          width: 80,
        },
        {
          prop: 'ruleName',
          label: '룰 이름',
          sortable: true,
        },
        {
          prop: 'severityName',
          label: '등급',
          sortable: true,
          width: 80,
        },
      ],
      devicetableColumn: [
        {
          type: 'selection',
          width: 70,
        },
        {
          prop: 'objName',
          label: '장비명',
          sortable: true,
          width: 562,
          searchable: true,
        },
      ],
      selectedPolicyData: {},
    };
  },
  methods: {
    open(item) {
      this.selectedPolicyData = item;

      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.formData.resetFields();
        this.$refs.scheduleForm.resetFields();
        this.activeStep = 1;
        this.selectedRowArrayForRule = [];

        this.periodCompFlag = true;
        if (item) {
          this.popupMode = 'update';
          this.formData = cloneDeep(item);
          this.targetTitle = `${this.targetData.objCompanyName} 보안정책 수정`;
          // schedule 데이터 폼에 바인딩 필요
          this.$nextTick(() => {
            this.scheduleForm.scheduleName = item.scheduleName;
            this.$refs.periodSettingCmp.setPeriodSettingData(item);
          });
        } else {
          this.popupMode = 'add';
          this.targetTitle = `${this.targetData.objCompanyName} 보안정책 추가`;
        }
        // 장비 정책 룰 목록 조회
        NetdeviceSecurityPolicySettingsAPI.getNetdeviceRuleList({ objCompanyId: this.targetData.objCompanyId }).then((res) => {
          if (res.data.success) {
            this.ruleTableData = res.data.data;
            // 업데이트일 경우
            if (this.popupMode === 'update') {
              NetdeviceSecurityPolicySettingsAPI.getNetdeviceRuleList({ objCompanyId: this.targetData.objCompanyId, policyId: item.policyId }).then((targetRes) => {
                forEach(targetRes.data.data, (targetValue) => {
                  this.$refs.settingRuleList.$children[0].toggleRowSelection(this.ruleTableData.find((targetItem) => targetItem.ruleId === targetValue.ruleId));
                });
                this.selectedRowArrayForRule = targetRes.data.data;
                this.selectedRowArrayForRuleOrigin = cloneDeep(this.selectedRowArrayForRule);
              });
            } else {
              this.ruleTableData = res.data.data;
            }
          }
        });
        // 정책이 등록되지 않은 해당밴더의 장비리스트를 조회한다.
        NetdeviceSecurityPolicySettingsAPI.getNetdeviceInNonPolicy({
          objCompanyId: this.targetData.objCompanyId, policyId: isEmpty(item) ? null : item.policyId,
        }).then((res) => {
          if (res.data.success) {
            const result = res.data.data;
            this.nonPolicyTableData = result;

            // 편집일 경우 장비 선택
            if (!isEmpty(item)) {
              this.$nextTick(() => {
                const deviceTable = this.$refs.deviceTable;
                item.objIds.forEach((objId) => {
                  deviceTable.$children[0].toggleRowSelection(find(result, { objId }));
                });
              });
            }
          }
        });
      });
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    close() {
      this.$refs.deviceTable.clearFilter();
      this.showSearchTool = false;
      this.periodCompFlag = false;
    },
    // 기본적으로 초기 formData에 대한 유효성 검사를 실행
    onClickNextStep() {
      // origin과 같다면 유효성 제외 필요
      this.$refs.formData.validate().then((valiResponse) => {
        if (valiResponse) {
          this.activeStep += 1;
        }
      }).catch(() => {});
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      if (this.activeStep === 2) {
        this.selectedRowArrayForRule = selectVal;
      } else if (this.activeStep === 3) {
        this.selectedRowArrayForDevice = selectVal;
      }
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    onClickSaveButton() {
      // 주기설정 데이터
      const data = this.$refs.periodSettingCmp.getPeriodSettingData();
      let scheduleParams = {};

      if (this.formData.scheduleFlag === 'Y') {
        scheduleParams = Object.assign(data, { scheduleName: this.scheduleForm.scheduleName, scheduleTypeId: 'CMPL_CHECK', scheduleContent: this.createScheduleContent(data) });
      }

      const target = '보안 정책';
      if (this.popupMode === 'add') {
        this.formData.scheduleParams = scheduleParams;
        this.formData.objCompanyId = this.targetData.objCompanyId;
        this.formData.selectedRowArrayForRule = this.selectedRowArrayForRule;
        this.formData.addedObjIds = map(this.selectedRowArrayForDevice, 'objId');

        const action = msgUtil.action.ADD;
        NetdeviceSecurityPolicySettingsAPI.insertNetdevicePolicy(this.formData).then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-data');
            this.clickCloseBtn();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      } else {
        // 수정 매커니즘
        const selectedPolicyData = this.selectedPolicyData;
        const targetObjs = map(this.selectedRowArrayForDevice, 'objId');
        const deletedObjIds = differenceWith(selectedPolicyData.objIds, targetObjs);
        const addedObjIds = differenceWith(targetObjs, selectedPolicyData.objIds);

        const formData = this.formData;
        Object.assign(formData, { deletedObjIds, addedObjIds, scheduleParams });

        const removeRuleList = [];
        // insert 대상은 selectedRowArrayForRule에 남아있게된다.
        forEach(this.selectedRowArrayForRuleOrigin, (item) => {
          const index = findIndex(this.selectedRowArrayForRule, item);
          if (index < 0) {
            removeRuleList.push(item);
          } else {
            this.selectedRowArrayForRule.splice(index, 1);
          }
        });
        // 룰 추가 및 삭제 리스트를 formData에 함께 전달한다.
        Object.assign(formData, { selectedRowArrayForRule: this.selectedRowArrayForRule, removeRuleList });
        const action = msgUtil.action.SAVE;
        NetdeviceSecurityPolicySettingsAPI.updateNetdevicePolicy(formData).then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-data');
            this.clickCloseBtn();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
    // 정책 아이디 중복 검사
    checkPolicyId(rule, value, callback) {
      if (isUndefined(value) || value === '') {
        callback(new Error('값을 입력해주세요.'));
      } else if (this.popupMode === 'update') {
        callback();
      } else {
        NetdeviceSecurityPolicySettingsAPI.checkPolicyId({ policyId: value }).then((res) => {
          if (res.data.data) {
            callback(new Error('이미 사용 중인 정책 ID입니다.'));
          } else {
            callback();
          }
        });
      }
    },
    createScheduleContent(record) {
      let scheduleContent;

      switch (record.schedulePeriod) {
        case 'N':
          scheduleContent = `${getDateToString(record.scheduleStarttime, 'YYYY년 MM월 DD일 HH:mm')}수행`;
          break;
        case 'D':
          scheduleContent = `매일 ${record.scheduleHour} : ${record.scheduleMinute}마다 수행`;
          break;
        case 'W': {
          const days = ['일', '월', '화', '수', '목', '금', '토'];

          let intervalDate;
          record.scheduleIntervalDate.split(',').forEach((date) => {
            if (isEmpty(intervalDate)) {
              intervalDate = days[parseInt(date, 10) - 1];
            } else {
              intervalDate += `,${days[parseInt(date, 10) - 1]}`;
            }
          });

          scheduleContent = `매주 ${intervalDate}요일 ${record.scheduleHour} : ${record.scheduleMinute}마다 수행`;
          break;
        }
        case 'M':
          scheduleContent = `매 ${record.scheduleIntervalMonth}월 ${record.scheduleIntervalDate}일에 ${record.scheduleHour} : ${record.scheduleMinute}마다 수행`;
          break;
        default:
          scheduleContent = EMPTY_TEXT;
          break;
      }

      return scheduleContent;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/RuleViolationSettings/SecurityRuleSettigns/popup/AddSecurityPolicySlidingPopup.vue